export const SET_ADDRESS = "set_address";
export const SET_CHECKED_ADDRESS = "set_checked_address";
export const SET_FINAL_ADDRESS = "set_final_address";
// export const SET_ADDRESS_LATLNG = "set_address_latlng";
export const SET_MUNICIPALITY = "set_municipality";
